<template>
    <v-layout row wrap>  
        <v-flex xs6></v-flex>
        <v-flex xs1>
            <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Rows Per Page"
            @change="handlePageSizeChange"
            ></v-select>
        </v-flex>
        <v-flex xs1 align-end><v-text-field disabled v-model="totalRecodsText"></v-text-field></v-flex>
        <v-flex xs4>
        <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="9"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
        ></v-pagination>
        </v-flex>
    </v-layout> 
</template>

<script>
export default {
  name: 'Pagination',
  components: {},
  props: {
    recordCount: Number  ,
    defaultPageSize: Number
  },
  data: () => ({
      page: 1,
      pageSize: 25,
      pageSizes: [25, 50, 100, 250, 500],
      currentPageNumber: 1,
  }),
  watch: {
  },
  computed: {
    totalPages(){
      return Math.floor(this.recordCount / this.pageSize) + 1;
    },
    totalRecodsText(){
      return this.rangeStart +"-" + this.rangeEnd + " (" + this.recordCount+ ")";
    },
    rangeStart(){
      return (((this.currentPageNumber - 1 ) * this.pageSize) + 1) ;
    },
    rangeEnd(){
      var rangeEnd = (((this.currentPageNumber - 1 ) * this.pageSize) + this.pageSize);
      if(rangeEnd > this.recordCount)
        rangeEnd = this.recordCount;
      return rangeEnd;
    },
  },
  created(){
      this.pageSize = this.defaultPageSize;
  },
  methods: {
    handlePageChange(number) {
      this.page = number;
      this.currentPageNumber = number;
      this.$emit('pageNumberChanged',number);
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.$emit('pageSizeChanged',size);
    },
  }
}
</script>